import React, { createContext } from "react";
import { ButtonBarGroupProps, ButtonBarGroupContextProps } from "./types";
import { StyleViewContainer } from "./styled-components";
import { ScrollViewFading } from "../../scrollViewFading";

const initialState = {
  selectedValue: "",
  onChange: () => {},
  isCondensed: false
};

export const GroupContext =
  createContext<ButtonBarGroupContextProps>(initialState);

export const ButtonBarGroup = ({
  children,
  selectedValue,
  onChange,
  isCondensed = false,
  showScrollBars = true,
  ...rest
}: ButtonBarGroupProps) => (
  <GroupContext.Provider value={{ selectedValue, onChange, isCondensed }}>
    <StyleViewContainer isCondensed={isCondensed} {...rest}>
      <ScrollViewFading showScrollBars={showScrollBars} {...rest}>
        {children}
      </ScrollViewFading>
    </StyleViewContainer>
  </GroupContext.Provider>
);
